import { ApiService } from '../ApiService';
import type { ApiResponse } from '../types';
import type { Organization } from '../../../hooks/useOrganization';

export interface FiscalSettings {
  vatRegistered: boolean;
  vatNumber?: string;
  vatRate: number;
  taxPaymentFrequency: string;
  fiscalYearStart: {
    month: number;
    day: number;
  };
  taxationSystem: string;
}

export interface BankDetails {
  id: string;
  bankName: string;
  accountNumber: string;
  iban?: string;
  swift?: string;
  currency: string;
  isPrimary: boolean;
}

export const organizationApi = {
  // Récupérer les informations de l'organisation
  getOrganization: (): Promise<ApiResponse<Organization>> =>
    ApiService.get<Organization>('/organization'),

  // Mettre à jour les informations de l'organisation
  updateOrganization: (data: Partial<Organization>): Promise<ApiResponse<Organization>> =>
    ApiService.put<Organization>('/organization', data),

  // Mettre à jour le logo de l'organisation
  updateLogo: (logoUrl: string): Promise<ApiResponse<{ logo: string }>> =>
    ApiService.post<{ logo: string }>('/organization/logo', { logo: logoUrl }),

  // Récupérer les paramètres fiscaux
  getFiscalSettings: (): Promise<ApiResponse<FiscalSettings>> =>
    ApiService.get<FiscalSettings>('/organization/fiscal-settings'),

  // Mettre à jour les paramètres fiscaux
  updateFiscalSettings: (data: Partial<FiscalSettings>): Promise<ApiResponse<FiscalSettings>> =>
    ApiService.put<FiscalSettings>('/organization/fiscal-settings', data),

  // Récupérer les coordonnées bancaires
  getBankDetails: (): Promise<ApiResponse<BankDetails[]>> =>
    ApiService.get<BankDetails[]>('/organization/bank-details'),

  // Ajouter des coordonnées bancaires
  addBankDetails: (data: Omit<BankDetails, 'id'>): Promise<ApiResponse<BankDetails>> =>
    ApiService.post<BankDetails>('/organization/bank-details', data),

  // Mettre à jour des coordonnées bancaires
  updateBankDetails: (id: string, data: Partial<BankDetails>): Promise<ApiResponse<BankDetails>> =>
    ApiService.put<BankDetails>(`/organization/bank-details/${id}`, data),

  // Supprimer des coordonnées bancaires
  deleteBankDetails: (id: string): Promise<ApiResponse<{ message: string }>> =>
    ApiService.delete<{ message: string }>(`/organization/bank-details/${id}`)
};
